import { api } from './api';

export interface PracticeAreaChild {
  id: string;
  name: string;
  slug: string;
}

export interface PracticeArea {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  parentId: string | null;
  sortOrder: number;
  isActive: boolean;
  createdAt: string;
  children: PracticeAreaChild[];
  caseCount: number;
  barristerCount: number;
}

interface ListPracticeAreasResponse {
  data: PracticeArea[];
}

export interface ListPracticeAreasParams {
  isActive?: boolean;
  parentId?: string;
  includeChildren?: boolean;
}

export async function fetchPracticeAreas(params: ListPracticeAreasParams = {}): Promise<PracticeArea[]> {
  const queryParams: Record<string, string> = {};
  if (params.isActive !== undefined) queryParams.isActive = String(params.isActive);
  if (params.parentId) queryParams.parentId = params.parentId;
  if (params.includeChildren !== undefined) queryParams.includeChildren = String(params.includeChildren);

  const res = await api.get<ListPracticeAreasResponse>('/practice-areas', { params: queryParams });
  return res.data.data ?? [];
}

export interface CreatePracticeAreaInput {
  name: string;
  slug?: string;
  description?: string;
  parentId?: string;
  sortOrder?: number;
  isActive?: boolean;
}

export async function createPracticeArea(input: CreatePracticeAreaInput): Promise<PracticeArea> {
  const res = await api.post<{ data: PracticeArea }>('/practice-areas', input);
  return res.data.data;
}

export async function updatePracticeArea(id: string, input: Partial<CreatePracticeAreaInput>): Promise<PracticeArea> {
  const res = await api.patch<{ data: PracticeArea }>(`/practice-areas/${id}`, input);
  return res.data.data;
}

export async function deletePracticeArea(id: string): Promise<void> {
  await api.delete(`/practice-areas/${id}`);
}
